/**
 * @generated SignedSource<<62e8a83843ff6a864b15efc53bd3d815>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AtlassianAccountAnyUserQuery$variables = {
  accountId: string;
};
export type AtlassianAccountAnyUserQuery$data = {
  readonly user: {
    readonly nickname?: string | null;
    readonly picture?: any;
  } | null;
};
export type AtlassianAccountAnyUserQuery = {
  response: AtlassianAccountAnyUserQuery$data;
  variables: AtlassianAccountAnyUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    }
  ],
  "type": "AtlassianAccountUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AtlassianAccountAnyUserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlassianAccountAnyUserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6e0f0528480a037829f3e1855a2ae6c",
    "id": null,
    "metadata": {},
    "name": "AtlassianAccountAnyUserQuery",
    "operationKind": "query",
    "text": "query AtlassianAccountAnyUserQuery(\n  $accountId: ID!\n) {\n  user(accountId: $accountId) {\n    __typename\n    ... on AtlassianAccountUser {\n      nickname\n      picture\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8752e7c61efee1493eb464e590aeee0b";

export default node;
